import React from "react";

function SearchIconButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      _ref$onMouseLeave = _ref.onMouseLeave,
      onMouseLeave = _ref$onMouseLeave === void 0 ? function () {} : _ref$onMouseLeave;
  return React.createElement("button", {
    className: "".concat(className ? className : ""),
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, React.createElement("svg", {
    viewBox: "0 0 50 50"
  }, React.createElement("line", {
    x1: "35",
    y1: "35",
    x2: "46",
    y2: "46"
  }), React.createElement("circle", {
    cx: "23",
    cy: "23",
    r: "16",
    fill: "none"
  }), "Sorry, your browser does not support inline SVG."));
}

export { SearchIconButton };